/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phone_Whatsapp_OptionalInputs */

const en_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone / WhatsApp (optional)`)
};

const es_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono / WhatsApp (opcional)`)
};

const fr_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone / WhatsApp (facultatif)`)
};

const de_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon / WhatsApp (optional)`)
};

const ja_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話番号 / WhatsApp (任意)`)
};

const zh_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电话 / WhatsApp (选填)`)
};

const ar_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهاتف / واتساب (اختياري)`)
};

const id_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepon / WhatsApp (opsional)`)
};

const it_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono / WhatsApp (opzionale)`)
};

const ru_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон / WhatsApp (необязательно)`)
};

const pt_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone / WhatsApp (opcional)`)
};

const ko_phone_whatsapp_optional = /** @type {(inputs: Phone_Whatsapp_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전화 / WhatsApp (선택 사항)`)
};

/**
* | output |
* | --- |
* | "Phone / WhatsApp (optional)" |
*
* @param {Phone_Whatsapp_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const phone_whatsapp_optional = /** @type {((inputs?: Phone_Whatsapp_OptionalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Whatsapp_OptionalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phone_whatsapp_optional(inputs)
	if (locale === "es") return es_phone_whatsapp_optional(inputs)
	if (locale === "fr") return fr_phone_whatsapp_optional(inputs)
	if (locale === "de") return de_phone_whatsapp_optional(inputs)
	if (locale === "ja") return ja_phone_whatsapp_optional(inputs)
	if (locale === "zh") return zh_phone_whatsapp_optional(inputs)
	if (locale === "ar") return ar_phone_whatsapp_optional(inputs)
	if (locale === "id") return id_phone_whatsapp_optional(inputs)
	if (locale === "it") return it_phone_whatsapp_optional(inputs)
	if (locale === "ru") return ru_phone_whatsapp_optional(inputs)
	if (locale === "pt") return pt_phone_whatsapp_optional(inputs)
	return ko_phone_whatsapp_optional(inputs)
});